/**
 * Virtual Human (虛擬人) API — 工作室「虛擬人」選單
 *
 * Backend (qubby_backend_new routes/userQubbyAi.js, USER_CONTEXT path → Firebase token 直驗):
 *   GET /api/qubbyAi/avatar/presets        → { success, data: { male:[], female:[] } }
 *     每筆 { id, nameKey, descKey, imageUrl }
 *   PUT /api/qubbyAi/avatar/update (FormData) → 寫 avatar.useAvatar + avatar.avatarId
 *     欄位：id(必填) / useAvatar('true'|'false') / qubbyAvatarId(預設編號，如 lily)
 */
import { get, api } from './client.js';

export async function fetchAvatarPresets() {
    const r = await get('/api/qubbyAi/avatar/presets');
    return r?.data || { male: [], female: [] };
}

export async function saveVirtualHuman({ avatarId, useAvatar, qubbyAvatarId }) {
    const fd = new FormData();
    fd.append('id', avatarId);
    fd.append('useAvatar', String(!!useAvatar));
    if (useAvatar && qubbyAvatarId) fd.append('qubbyAvatarId', qubbyAvatarId);
    return api('PUT', '/api/qubbyAi/avatar/update', { body: fd });
}
